export default __webpack_public_path__ + "static/media/pliers.c4304f9a.png";